import { Grid } from "@mui/material"
import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet-async"
import FormSection from "./components/formSection"
import { SignupComponentsWrapper } from "./styles"
import DescriptionSection from "./components/descriptionSection"
import OtpSection from "./components/otp"
export default function SignupComponents() {
	const { t } = useTranslation()
	
	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>{t("REGISTRATION.PAGE_TITLE")}</title>
				<meta name="description" content={t("REGISTRATION.PAGE_DESCRIPTION")} />
			</Helmet>
			<SignupComponentsWrapper>
			<Grid container sx={{ height: "100%" }}>
				<Grid item xs={12} md={6}>
					<FormSection />
				</Grid>
				<Grid
					item
					sx={{
						display: {
							xs: "none",
							sm: "none",
							md: "block",
						},
					}}
					sm={6}
				>
					<DescriptionSection />
				</Grid>
			</Grid>
		</SignupComponentsWrapper>
		</>
	)
}
